import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { whiteColor } from 'src/constants';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  crossTableStatus: {
    display: 'flex',
    alignItems: 'center',
  },
  crossTableStatusColorWrapper: {
    position: 'relative',
    width: '20px',
    height: '20px',
  },
  crossTableStatusDot: {
    backgroundColor: whiteColor,
    width: '3px',
    height: '3px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)',
  },
  crossTableStatusColor: {
    width: '20px',
    minWidth: '20px',
    height: '20px',
    borderRadius: '4px',
  },
  statusList: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: '20px',
    width: '100%',
    paddingTop: '8px',
    position: 'absolute',
    zIndex: '6',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      overflow: 'auto',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginBottom: '0',
    },
  },
  statusListItem: {
    whiteSpace: 'nowrap',
  },
}));
